export function genericSearchValues<TItem>(
    items: TItem[],
    searchTerm: string,
    valueSelector: (i: TItem) => string,
    accept?: (searchTermLowerCase: string, value: string) => boolean
): TItem[] {
    const normalizedTerm = searchTerm?.toLowerCase();
    let searchResult: TItem[] = [];

    if (typeof accept !== "function") {
        accept = (_, value) => (value ?? "").toLowerCase().indexOf(normalizedTerm) >= 0;
    }

    try {
        searchResult = (items ?? []).filter(item => {
            if (item == null) return false;
            const value = valueSelector(item);
            return accept(normalizedTerm, value);
        });
    } catch {}

    return searchResult;
}

export function searchStringValues(items: string[], searchTerm: string) {
    return genericSearchValues(items, searchTerm, item => item);
}
